"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var ToggleButton = (0, material_1.styled)(material_1.ToggleButton)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return ({
        padding: 0,
        textTransform: 'capitalize',
        border: "1px solid ".concat((_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main),
        lineHeight: 1.6,
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.fontWeightRegular,
        color: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.main,
        '[disabled]': {
            color: 'rgba(255, 255, 255, 0.35)',
            pointerEvents: 'none',
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.common.white,
            fontWeight: theme.typography.fontWeightMedium,
            border: "1px solid ".concat(theme.palette.text.secondary),
            color: theme.palette.text.secondary,
            '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                borderLeft: "1px solid ".concat(theme.palette.text.secondary),
            },
        },
        '&.Mui-selected.MuiToggleButton-primary, &.MuiToggleButton-primary:hover': {
            border: "1px solid ".concat(theme.palette.primary.main),
            color: theme.palette.primary.main,
            ':hover': { backgroundColor: '#FFF3F7' },
            '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                borderLeft: "1px solid ".concat(theme.palette.primary.main),
            },
        },
        '&.Mui-selected.MuiToggleButton-secondary, &.MuiToggleButton-secondary:hover': {
            border: '1px solid rgba(132, 71, 240, 0.6)',
            color: 'rgba(132, 71, 240, 0.6)',
            '&:hover': {
                backgroundColor: 'rgba(132, 71, 240, 0.1)',
            },
            '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                borderLeft: '1px solid rgba(132, 71, 240, 0.6)',
            },
        },
        ':focus-visible': __assign({}, theme.focusVisibleStyles),
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(ToggleButton, {
    size: 'small',
    tabIndex: 0,
});
